export function getReportName(report: any): string {
  return report ? report.name || 'Anomaly Report' : ''
}
